<template>
	<div class="infor contains">
		<div class="content-main">
			<div class="flex-box">
				<div class="title">个人信息</div>
				<div class="flex">
					<div class="flex_left">
						<div class="option">
							<span class="txt">账号</span>
							<div class="content">
								<div class>{{User.Account}}</div>
							</div>
						</div>
						<div class="option">
							<span class="txt">姓名</span>
							<div class="content">
								<el-input v-model="UserModel.RealName" placeholder="请输入姓名"></el-input>
							</div>
						</div>
						<div class="option">
							<span class="txt">昵称</span>
							<div class="content">
								<el-input v-model="UserModel.NickName" placeholder="请输入昵称"></el-input>
							</div>
						</div>
						<div class="option">
							<span class="txt">手机</span>
							<div class="content">
								<el-input v-model="UserModel.Mobile" placeholder="请输入手机" v-if="UPdateMobile"></el-input>
								<div v-if="UPdateMobile!=true">
									<span>{{UserModel.Mobile}}</span>
									<span>&nbsp</span>
									<span style="color:#87B2EB;cursor: pointer;" @click="UpdateMobile">修改</span>
								</div>
							</div>
						</div>
						<div class="option">
							<span class="txt">&nbsp;</span>
							<div class="content">
								<div class="save" style="margin-top:0;">
									<el-button type="primary" @click="Update_LoginMessage">保存</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="title">密码设置</div>
				<div class="flex">
					<div class="flex_left">
						<div class="option">
							<span class="txt">原密码</span>
							<div class="content">
								<el-input v-model="UserModel.Password_1" type="number" placeholder="请输入原密码" show-password></el-input>
							</div>
						</div>
						<div class="option">
							<span class="txt">新密码</span>
							<div class="content">
								<el-input v-model="UserModel.Password_2" type="number" placeholder="请输入新密码" show-password></el-input>
							</div>
						</div>
						<div class="option">
							<span class="txt">确认密码</span>
							<div class="content">
								<el-input v-model="UserModel.Password_3" type="number" placeholder="请确认密码" show-password></el-input>
							</div>
						</div>
						<div class="option">
							<span class="txt">&nbsp;</span>
							<div class="content">
								<div class="save" style="margin-top:0;">
									<el-button type="primary" @click="Update_LoginPass">保存</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Base64 } from 'js-base64'
export default {
	name: 'infor',
	props: [],
	data() {
		return {
			UPdateMobile: false,
			User: {
				Id: 0,
				Account: '',
				RealName: '',
				NickName: '',
				Mobile: '',
				Password: ''
			},
			UserModel: {
				Account: '',
				RealName: '',
				NickName: '',
				Mobile: '',
				Password_1: '',
				Password_2: '',
				Password_3: ''
			}
		}
	},
	watch: {},
	mounted: function() {
		this.show()
	},
	methods: {
		UpdateMobile() {
			let $this = this
			$this.UPdateMobile = true
		},
		show() {
			let $this = this
			this.axios
				.get('User/Login_information', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
			

					$this.User.Id = data.data.id
					$this.User.Account = data.data.account
					$this.User.RealName = data.data.realName
					$this.User.NickName = data.data.nickName
					$this.User.Mobile = data.data.mobile
					$this.User.Password = data.data.password

					$this.UserModel.RealName = data.data.realName
					$this.UserModel.NickName = data.data.nickName
					$this.UserModel.Mobile = data.data.mobile
				})
		},
		//修改登录人的当前信息
		Update_LoginMessage() {
			var boole = true
			let $this = this
			if ($this.UserModel.RealName == '') {
				$this.$message.error('请输入姓名')
				boole = false
				
			}else if($this.UserModel.RealName.length>20){
				$this.$message.error('姓名不能超过20字符')
				boole = false
			}
			else if ($this.UserModel.NickName == '') {
				$this.$message.error('请输入姓名')
				boole = false
			} else if($this.UserModel.NickName.length>20){
			   $this.$message.error('昵称不能超过20字符')
				boole = false
			} else if ($this.UserModel.Mobile == '') {
				$this.$message.error('请输入电话')
				boole = false
			} else if($this.UserModel.Mobile.length>11){
				$this.$message.error('手机号不能超过11位')
				boole=false
			}

			if (boole) {
				this.axios
					.post(
						'User/Update_LoginMessage?Id=' +
							$this.User.Id +
							'&RealName=' +
							$this.UserModel.RealName +
							'&NickName=' +
							$this.UserModel.NickName +
							'&Mobile=' +
							$this.UserModel.Mobile,
						{
							headers: {
								'Content-Type': 'application/json'
							}
						}
					)
					.then(function(data) {
						if (data.data.message == '成功') {
							$this.$message(data.data.message)
							$this.UserModel.RealName = ''
							$this.UserModel.NickName = ''
							$this.UserModel.Mobile = ''
							$this.show()
							$this.UPdateMobile = false
						} else {
							$this.$message.error(data.data.message)
						}
					})
			}
		},
		//修改密码
		Update_LoginPass() {
			var boole = true
			let $this = this
			debugger
			// if ($this.UserModel.Password_1 != $this.User.Password) {
			// 	alert('原密码不正确')
			// 	boole = false
			// } else 
			if ($this.UserModel.Password_2.length < 6 && $this.UserModel.Password_2.length<17) {
				$this.$message.error('新密码必须六位或六位以上,16位及以下')
				boole = false
			} else if (
				$this.UserModel.Password_3 != $this.UserModel.Password_2
			) {
				$this.$message.error('确认密码必须和新密码一致')
				boole = false
			}

			if (boole) {
				this.axios
					.post(
						'User/Update_LoginPass?id=' +
							$this.User.Id +
							'&pass=' +
							$this.UserModel.Password_3,
						{
							headers: {
								'Content-Type': 'application/json',
								'auditChannel':Base64.encode('后台-修改密码')
							}
						}
					)
					.then(function(data) {
						if (data.data.message == '成功') {
							$this.$message(data.data.message)
							$this.UserModel.Password_1 = ''
							$this.UserModel.Password_2 = ''
							$this.UserModel.Password_3 = ''
							$this.show()

							let loginModel = JSON.parse(
								localStorage.getItem($this.LoginInfo)
							)
							//             let $this = this
							$this.axios
								.get('Login', {
									params: { token: loginModel.token }
								})
								.then(function({ data }) {
									$this.$message.success('退出成功')
									localStorage.clear()
									$this.$router.push({ path: '/login' })
								})
						} else {
							$this.$message.error(data.data.message)
						}
					})
			}
		}
	}
}
</script>

<style scoped>
.content-tit {
	border-bottom: 1px solid #ddd;
}
.content-tit h2 {
	font-size: 20px;
}
.flex-box {
	width: 100%;
}

/*个人信息*/
.title {
	font-size: 16px;
	font-weight: bold;
	padding: 30px 0 20px 0;
	border-bottom: 1px solid #ddd;
}
.flex {
	width: 980px;
	max-height: 315px;
	padding-left: 20px;
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding-top: 20px;
	padding-bottom: 30px;
}
.option {
	margin-top: 20px;
	min-height: 40px;
	line-height: 40px;
}
.txt {
	display: inline-block;
	float: left;
	min-width: 120px;
	color: #999;
	font-size: 14px;
}
.content {
	float: left;
}
.content {
	font-size: 16px;
}
.points {
	font-size: 14px;
	color: #999;
	line-height: 50px;
}
.save {
	margin-top: 90px;
}
.preview {
	text-align: center;
}
.img_box {
	width: 270px;
	height: 170px;
	border: 1px solid #ddd;
	margin-top: 30px;
}
.img_box img {
	display: block;
	width: 100%;
}
.radio {
	padding-top: 10px;
	padding-bottom: 30px;
}
.switch {
	margin-top: 30px;
}
</style>
<style>
.infor .el-input__inner {
	background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/setting/infor.vue